import type { ComponentProps } from 'react';
import { forwardRef } from 'react';

import { useFenrirTranslation } from '../../../locales/use-fenrir-translation';
import type { BaseStatusChipProps } from '../base-status-chip';
import { BaseStatusChip } from '../base-status-chip';

export type NotificationStatusOption = 'new';

export interface NotificationStatusChipProps
  extends Omit<BaseStatusChipProps, 'label' | 'variant'> {
  status: NotificationStatusOption;
}

const variantMapping: Record<
  NotificationStatusChipProps['status'],
  ComponentProps<typeof BaseStatusChip>['variant']
> = {
  new: 'new',
};

export const NotificationStatusChip = forwardRef<
  HTMLDivElement,
  NotificationStatusChipProps
>(({ status, ...rest }: NotificationStatusChipProps, ref) => {
  const { t } = useFenrirTranslation({ keyPrefix: 'statusChip' });

  return (
    <BaseStatusChip
      ref={ref}
      label={t(status)}
      variant={variantMapping[status]}
      {...rest}
    />
  );
});
